import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  getStripeCoupons,
  createOrg,
  createSeller,
  getCartwheelTeams,
  getCityAndTeam,
  getMerchantUsers,
  getStoreById,
  updateSeller,
  syncStoreStripeAccount,
  getStripeCustomerById,
  createSellerStripeAccount,
} from "../../api/admin.js";
import ModalBasic from "../../components/ModalBasic.jsx";
import TabbedNavigation from "../../components/TabbedNavigation.jsx";
import { Autocomplete } from "@react-google-maps/api";
import { useGoogleMaps } from "@/utils/googleMaps.jsx";
import config from "@/config";
import { formatPhoneNumber, parseAddress } from "../../utils/Utils.js";
import * as turf from "@turf/turf";
import { addToast, getMerchants } from "../../store/app/action.js";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton, SecondaryButton } from "../../components/Buttons.jsx";
import UsersTable from "./usersTable.jsx";
import Badge from "../../components/Badges.jsx";
import InventoryFeed from "./inventoryFeed.jsx";
import moment from "moment";
import {
  FindStripeCustomerModal,
  FindStripeSubscriptionModal,
} from "../merchants/merchantTable.jsx";
import Tooltip from "../../components/Tooltip.jsx";
import Loader from "../../components/Loader.jsx";
import { Multiselect } from "multiselect-react-dropdown";
import { FaArrowsRotate } from "react-icons/fa6";
import {useHotkeys} from "react-hotkeys-hook";

const dspMapping = {
  display: "name",
  value: "_id",
};
const merchantMapping = {
  display: "name",
  value: "id",
};

const StoreModal = ({
  id,
  setStoreID,
  closeModal,
  dspProviders,
  triggerGetMerchants,
  markets,
  teams,
  storeType,
}) => {
  const [store, setStore] = useState({});
  const [newSubscriptionType, setNewSubscriptionType] =
    useState("basic_monthly");
  const [syncingStripe, setSyncingStripe] = useState(false);
  const [syncStripeSuccess, setSyncStripeSuccess] = useState(false);
  const [currentView, setCurrentView] = useState("payemnt");
  const [users, setUsers] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [tempAddress, setTempAddress] = useState(null);
  const [manualMarket, setManualMarket] = useState(false);
  const { merchants } = useSelector((state) => state.app);
  const [newMerchantName, setNewMerchantName] = useState("");
  const [newMerchantBillingEmail, setNewMerchantBillingEmail] = useState("");
  const autoComplete = React.useRef(null);
  const [showCreateNewMerchant, setShowCreateNewMerchant] = useState(false);
  const [creatingOrg, setCreatingOrg] = useState(false);
  const [createdOrg, setCreatedOrg] = useState(false);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [freeTrialDays, setFreeTrialDays] = useState(14);
  const [cartwheelTeams, setCartwheelTeams] = useState([]);
  const [trialDayError, setTrialDayError] = useState("");

  const [createNewSubscription, setCreateNewSubscription] = useState(true);
  const [existingStripeSubscription, setExistingStripeSubscription] =
    useState("");
  const [existingStripeCustomer, setExistingStripeCustomer] = useState("");
  const [showFindStripeCustomerModal, setShowFindStripeCustomerModal] =
    useState(false);
  const [showFindStripeSubscriptionModal, setShowFindStripeSubscriptionModal] =
    useState(false);
  const [stripeCoupons, setStripeCoupons] = useState([]);
  const [selectedCoupons, setSelectedCoupons] = useState([]);
  const [forceRefetch, setForceRefetch] = useState(false);

  const { isLoaded } = useGoogleMaps();

  const [isCtrlDown, setIsCtrlDown] = useState(false);
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Control") setIsCtrlDown(true);
    };
    const handleKeyUp = (e) => {
      if (e.key === "Control") setIsCtrlDown(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);
  useHotkeys(
    "ctrl+s",
    () => {
      if (store?.id !== "new") setCurrentView("settings");
    },
    { preventDefault: true }
  );

  useHotkeys(
    "ctrl+u",
    () => {
      if (store?.id !== "new") setCurrentView("users");
    },
    { preventDefault: true }
  );

  useHotkeys(
    "ctrl+p",
    () => {
      if (store?.id !== "new") setCurrentView("payment");
    },
    { preventDefault: true }
  );

  useHotkeys(
    "ctrl+i",
    () => {
      if (store?.id !== "new") setCurrentView("feed");
    },
    { preventDefault: true }
  );

  useHotkeys(
    "ctrl+p",
    () => {
      setShowFindStripeCustomerModal(true)
    },
    { preventDefault: true }
  )

  console.log(showFindStripeCustomerModal)
  const [sellerStripeCustomer, setSellerStripeCustomer] = useState(null);
  useEffect(() => {
    if (store?.stripe_cust_id) {
      getStripeCustomerById(store.stripe_cust_id).then((res) => {
        setSellerStripeCustomer(res.customer);
      });
    } else {
      setSellerStripeCustomer(null);
    }
  }, [store?.stripe_cust_id]);
  const [findStripeCustomerModal, setFindStripeCustomerModal] = useState(false);

  useEffect(() => {
    if (!showBillingModal) {
      setTrialDayError("");
      setNewSubscriptionType("basic_monthly");
      setFreeTrialDays(14);
      setCreateNewSubscription(true);
      setExistingStripeSubscription("");
      setExistingStripeCustomer("");
    }
  }, [showBillingModal]);

  const dispatch = useDispatch();
  const badge = useMemo(() => {
    if (!store) {
      return null;
    }
    if (!store.stripe_account_id) {
      return <Badge color="gray">No Stripe Account</Badge>;
    }
    if (!store.stripe_verified) {
      return <Badge color="yellow">Not Verified</Badge>;
    }
    return <Badge color="green">Verified</Badge>;
  }, [store]);

  const submit = async () => {
    // check all required fields are there
    let err = false;
    [...fields, ...paymentFields].forEach((field) => {
      if (field.required && !store?.[field.path]) {
        dispatch(
          addToast({
            message: `${field.label} is required`,
            type: "error",
            timer: 5,
          })
        );
        err = true;
        return;
      }
      if (field.formatter) {
        store[field.path] = field.formatter(store[field.path]);
      }
    });
    store.tobacco_enabled = store.enabled_categories.includes("tobacco");
    store.alcohol_enabled = store.enabled_categories.includes("alcohol");
    store.enabled = store.enabled_temp.includes("enabled");
    if (err) {
      return;
    }

    if (store.id === "new") {
      setProcessing(true);
      try {
        store.free_trial_days = freeTrialDays;
        store.subscription_type = newSubscriptionType;
        store.link_existing_subscription = existingStripeSubscription?.id;
        store.link_existing_stripe_customer = existingStripeCustomer?.id;
        store.coupons = selectedCoupons.map((coupon) => coupon.id);
        const res = await createSeller(store);
        setShowBillingModal(false);
        res.seller.enabled_categories = [];
        if (res.seller.tobacco_enabled) {
          res.seller.enabled_categories.push("tobacco");
        }
        if (res.seller.alcohol_enabled) {
          res.seller.enabled_categories.push("alcohol");
        }
        setStore(res.seller);
        setStoreID(res.seller.store_id);
        dispatch(
          addToast({
            message: `${store.name} created successfully ( ${res.seller.store_id} )`,
            type: "success",
            timer: 10,
          })
        );
        triggerGetMerchants();
      } catch (e) {
        dispatch(
          addToast({
            message: "Unable to create store, please try again",
            type: "error",
          })
        );
      } finally {
        setProcessing(false);
      }
    } else {
      setProcessing(true);
      try {
        const res = await updateSeller(store._id, store);
        res.seller.enabled_categories = [];
        if (res.seller.tobacco_enabled) {
          res.seller.enabled_categories.push("tobacco");
        }
        if (res.seller.alcohol_enabled) {
          res.seller.enabled_categories.push("alcohol");
        }
        if (res.seller.enabled) {
          res.seller.enabled_categories.push("enabled");
        }
        setForceRefetch(new Date());
        dispatch(
          addToast({
            message: `${store.name} updated successfully ( ${res.seller.store_id} )`,
            type: "success",
            timer: 10,
          })
        );
        triggerGetMerchants();
      } catch (e) {
        dispatch(
          addToast({
            message: "Unable to update store, please try again",
            type: "error",
          })
        );
      } finally {
        setProcessing(false);
      }
    }
  };

  useEffect(() => {
    if (!showCreateNewMerchant) {
      setNewMerchantName("");
      setNewMerchantBillingEmail("");
    }
  }, [showCreateNewMerchant]);
  useEffect(() => {
    getStripeCoupons().then((res) => {
      setStripeCoupons(res?.coupons);
    });
    callGetCartwheelTeams();
  }, []);
  useEffect(() => {
    setCreatedOrg(false);
    setSyncingStripe(false);
    setSyncStripeSuccess(false);
    if (!id) {
      setCurrentView("settings");
      setStore({});
    } else if (id === "new") {
      setStore({
        id: "new",
        name: "",
        legal_name: "",
        store_id: "",
        subname: "",
        email: "",
        phone: "",
        _org: "",
        _city: "",
        _team: "",
        address: "",
        address_line2: "",
        cartwheel_team_id: "",
        city: "",
        state: "",
        zip: "",
        direct_web_url: "",
        enabled_providers: dspProviders.map((provider) => provider._id),
        create_user_account: ["create_user_account"],
        with_billing: ["with_billing"],
        enabled_categories: ["tobacco", "alcohol"],
        enabled_temp: [""],
        payment_gateway: "stripe",
      });
    } else {
      getStoreById(id).then((res) => {
        res.store.enabled_categories = [];
        res.store.enabled_temp = [];
        if (res.store.enabled) {
          res.store.enabled_temp.push("enabled");
        }
        if (res.store.tobacco_enabled) {
          res.store.enabled_categories.push("tobacco");
        }
        if (res.store.alcohol_enabled) {
          res.store.enabled_categories.push("alcohol");
        }
        if (!res.store.cartwheel_team_id) {
          res.store.cartwheel_team_id = "";
        }
        setStore(res.store);
      });
      getMerchantUsers(id).then((res) => {
        setUsers(res.users);
      });
    }
  }, [id, dspProviders, forceRefetch]);
  const callGetCartwheelTeams = async () => {
    try {
      const res = await getCartwheelTeams();
      setCartwheelTeams(res);
    } catch (e) {}
  };

  const handleChange = (e) => {
    const field = [...fields, ...paymentFields].find(
      (field) => field.name === e.target.name
    );
    if (field.type === "google-map-autocomplete") {
      setTempAddress(e.target.value);
    } else if (field.type === "checkbox") {
      setStore({
        ...store,
        [e.target.name]: e.target.checked,
      });
    } else if (field.type === "checkboxes") {
      setStore({
        ...store,
        [e.target.name]: e.target.checked
          ? [...store?.[e.target.name], e.target.value]
          : store?.[e.target.name].filter((value) => value !== e.target.value),
      });
    } else if (field.type === "dropdown") {
      if (field.path === "_org") {
        if (e.target.value === "new") {
          setShowCreateNewMerchant(true);
          return;
        }
      }
      if (field.path === "_city") {
        if (!manualMarket) {
          return;
        }
        const m = markets.find((market) => market._id === e.target.value);
        const team = teams.find((team) => team.zone === m.zone);
        if (team) {
          setStore({
            ...store,
            [field.path]: e.target.value,
            _team: team._id,
          });

          return;
        }
      }

      setStore({
        ...store,
        [field.path]: e.target.value,
      });
    } else {
      setStore({
        ...store,
        [e.target.name]: e.target.value,
      });
    }
  };

  const paymentFields = useMemo(() => {
    return [
      { type: "divider", section: "Order Payment Settings" },
      {
        type: "dropdown",
        name: "payment_gateway",
        label: "Payment Gateway",
        required: true,
        path: "payment_gateway",
        values: [
          { id: "stripe", name: "Stripe" },
          { id: "nmi", name: "NMI" },
          { id: "frame", name: "Frame" },
        ],
        mapping: { display: "name", value: "id" },
      },
      {
        type: "custom",
        name: "Stripe",
        label: "Stripe Connect Account",
        hide: ["nmi", "frame"].includes(store?.payment_gateway),
        content: (
          <>
            <div>
              {store.stripe_account_id + " "}
              {badge}
            </div>
            <SecondaryButton
              loading={syncingStripe}
              success={syncStripeSuccess}
              onClick={async () => {
                setSyncingStripe(true);
                const result = await syncStoreStripeAccount(store.store_id);
                setSyncingStripe(false);
                setSyncStripeSuccess(true);
                setStore({ ...store, stripe_verified: result.stripe_verified });
                triggerGetMerchants();
                setTimeout(() => {
                  setSyncStripeSuccess(false);
                }, 2000);
              }}
            >
              <FaArrowsRotate />
            </SecondaryButton>
            <div className={"flex items-center gap-1"}>
              {store.stripe_account_id && (
                <PrimaryButton
                  size="sm"
                  onClick={() => {
                    window.open(
                      `https://dashboard.stripe.com/${
                        config.environment === "development" ? "test/" : ""
                      }connect/accounts/${store.stripe_account_id}`,
                      "_blank"
                    );
                  }}
                >
                  View on Stripe
                </PrimaryButton>
              )}
            </div>
          </>
        ),
      },
      {
        type: "text",
        name: "nmi_gateway_id",
        label: "NMI Gateway ID",
        field: "nmi_gateway_id",
        hide: store?.payment_gateway !== "nmi",
        path: "nmi_gateway_id",
        required: store?.payment_gateway === "nmi",
      },
      {
        label: "NMI Private Token",
        name: "nmi_private_key",
        type: "text",
        hide: store?.payment_gateway !== "nmi",
        path: "nmi_private_key",
        required: store?.payment_gateway === "nmi",
      },
      {
        label: "NMI Public Token",
        name: "nmi_public_key",
        type: "text",
        hide: store?.payment_gateway !== "nmi",
        path: "nmi_public_key",
        required: store?.payment_gateway === "nmi",
      },
      {
        label: "Frame Public Key",
        name: "frame_public_key",
        type: "text",
        hide: store?.payment_gateway !== "frame",
        path: "frame_public_key",
        required: store?.payment_gateway === "frame",
      },
      {
        label: "Frame Private Key",
        name: "frame_private_key",
        type: "text",
        hide: store?.payment_gateway !== "frame",
        path: "frame_private_key",
        required: store?.payment_gateway === "frame",
      },
      {
        type: "divider",
        section: "Transaction Fee Payment Settings",
        hide: store?.payment_gateway !== "nmi",
      },
      {
        type: "checkbox",
        label: (
          <span className="flex gap-1 items-center">
            Aggregated Transaction Fee Billing
            <Tooltip size={"lg"}>
              Use Merchant's stripe account & payment method.
            </Tooltip>
          </span>
        ),
        name: "aggregated_transaction_fee_billing",
        path: "aggregated_transaction_fee_billing",
        hide: !["nmi", "frame"].includes(store?.payment_gateway)
      },
      {
        type: "custom",
        label: "Stripe Customer ID",
        hide:
          (!["nmi", "frame"].includes(store?.payment_gateway)) ||
          store.aggregated_transaction_fee_billing,
        content: (
          <div className="flex gap-2 items-center">
            {!store.stripe_cust_id && !sellerStripeCustomer ? (
              "Not linked"
            ) : sellerStripeCustomer ? (
              <>
                {sellerStripeCustomer.id}
                <Tooltip>{sellerStripeCustomer.email}</Tooltip>
                <PrimaryButton
                  size="sm"
                  onClick={() => {
                    window.open(
                      `https://dashboard.stripe.com/${
                        config.environment === "development" ? "test/" : ""
                      }customers/${sellerStripeCustomer.id}`,
                      "_blank"
                    );
                  }}
                >
                  View on Stripe
                </PrimaryButton>
              </>
            ) : (
              <Loader hideText size={8} />
            )}
            <SecondaryButton
              loading={processing}
              onClick={() => {
                setFindStripeCustomerModal(true);
              }}
              size="sm"
            >
              {store.stripe_cust_id || sellerStripeCustomer
                ? "Replace"
                : "Link Existing"}
            </SecondaryButton>
            {!store.stripe_cust_id && (
              <PrimaryButton
                loading={processing}
                onClick={async () => {
                  setProcessing(true);
                  try {
                    let aggregated = store.aggregated_transaction_fee_billing;
                    const newStore = await createSellerStripeAccount({
                      email: store.email,
                      name: store.name,
                      store_id: store.store_id,
                    });
                    newStore.seller.aggregated_transaction_fee_billing =
                      aggregated;
                    setStore({ ...store, ...newStore.seller });
                    setProcessing(false);
                    dispatch(getMerchants());
                    dispatch(
                      addToast({
                        type: "success",
                        message: "Stripe Account Created and Linked",
                        timer: 5,
                      })
                    );
                  } catch (e) {
                    let message = "please try again";
                    try {
                      const serverMessage = e.response?.data?.message;
                      if (serverMessage) {
                        message = serverMessage;
                      }
                    } catch {}

                    dispatch(
                      addToast({
                        type: "error",
                        message: "Error creating stripe account, " + message,
                        timer: 5,
                      })
                    );
                    setProcessing(false);
                  }
                }}
              >
                Create
              </PrimaryButton>
            )}
          </div>
        ),
      },
    ];
  }, [
    store,
    syncingStripe,
    syncStripeSuccess,
    processing,
    sellerStripeCustomer,
  ]);
  const fields = useMemo(() => {
    return [
      { type: "divider", section: "Basic Store Information" },
      {
        type: "text",
        name: "store_id",
        label: `Store ID ${
          store?.id === "new" ? "(auto-generated on save)" : ""
        }`,
        path: "store_id",
        disabled: true,
      },
      {
        type: "text",
        name: "legal_name",
        label: "Legal Business Name",
        required: true,
        path: "legal_name",
      },
      {
        type: "dropdown",
        name: "Account",
        label: "Account",
        emptyValue: "Select an account",
        createNewValue: "Create New Account",
        required: true,
        path: "_org",
        values: merchants,
        mapping: merchantMapping,
      },
      {
        type: "text",
        name: "name",
        label: "Store Name",
        required: true,
        path: "name",
      },
      {
        type: "text",
        name: "email",
        label: "Email",
        required: true,
        path: "email",
      },
      {
        type: "text",
        name: "phone",
        label: "Phone",
        path: "phone",
        required: true,
        formatter: formatPhoneNumber,
      },
      {
        type: "google-map-autocomplete",
        name: "address",
        label: "Address",
        required: true,
        path: "address",
        value:
          tempAddress ??
          `${store?.address || ""} ${store?.city || ""} ${store?.state || ""} ${
            store?.zip || ""
          }`,
      },
      {
        type: "text",
        name: "address_line2",
        label: "Address Line 2 (Suite, Apt, etc)",
        path: "address_line2",
        required: false,
      },
      {
        type: "dropdown",
        disabled: !manualMarket,
        name: "Market",
        label: "Market",
        required: false,
        path: "_city",
        values: markets,
        invisible: !manualMarket,
        mapping: { display: "name", value: "_id" },
      },
      { type: "divider", section: "Direct Store Settings" },
      {
        type: "checkboxes",
        name: "enabled_temp",
        label: "Enabled",
        path: "enabled_temp",
        hide: store?.id === "new",
        values: [{ name: "Enabled", value: "enabled" }],
        mapping: { display: "name", value: "value" },
      },
      {
        type: "text",
        name: "direct_web_url",
        label: "URL" + (store?.id === "new" ? "(auto-generated on save)" : ""),
        required: store?.id !== "new",
        disabled: store?.id === "new",
        path: "direct_web_url",
        field_prefix: config.direct_web_prefix,
      },
      {
        type: "checkboxes",
        name: "enabled_categories",
        label: "Enabled Categories",
        path: "enabled_categories",
        values: [
          { name: "Tobacco", value: "tobacco" },
          { name: "Alcohol", value: "alcohol" },
        ],
        mapping: { display: "name", value: "value" },
      },
      {
        type: "checkboxes",
        name: "enabled_providers",
        label: "Enabled DSPs",
        required: true,
        path: "enabled_providers",
        values: dspProviders,
        mapping: dspMapping,
      },
      {
        type: "dropdown",
        name: "cartwheel_team",
        label: "Cartwheel Team",
        required: false,
        path: "cartwheel_team_id",
        values: cartwheelTeams,
        emptyValue: "Disabled",
        hide: store?.id === "new",
        mapping: { display: "name", value: "id" },
      },
      {
        type: "checkboxes",
        hide: store?.id !== "new",
        name: "create_user_account",
        label: "Create User Account?",
        path: "create_user_account",
        values: [{ name: "Create User Account", value: "create_user_account" }],
        mapping: { display: "name", value: "value" },
        formatter: (value) => !!(value || []).length,
      },
      {
        type: "checkboxes",
        hide: !store?.create_user_account?.includes?.("create_user_account"),
        name: "with_billing",
        label: "With Billing Permission",
        path: "with_billing",
        values: [{ name: "With Billing Permission", value: "with_billing" }],
        mapping: { display: "name", value: "value" },
        formatter: (value) => !!(value || []).length,
      },
    ];
  }, [
    store,
    tempAddress,
    manualMarket,
    markets,
    merchants,
    dspProviders,
    syncingStripe,
    syncStripeSuccess,
  ]);

  const form = useCallback(
    (fields) => {
      if (!store) {
        return null;
      }
      return (
        <div className="py-4">
          {fields.map((field) => {
            if (field.hide) return null;
            switch (field.type) {
              case "dropdown":
                return (
                  <div
                    key={field.name}
                    className={"mb-4 " + (field.invisible ? "hidden" : "")}
                  >
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor={field.name}
                    >
                      {field.label}
                      {field.required && (
                        <span className="text-red-500"> *</span>
                      )}
                    </label>
                    <select
                      className="form-select"
                      name={field.name}
                      value={store?.[field.path]}
                      onChange={handleChange}
                      disabled={field.disabled}
                    >
                      <option value="">{field.emptyValue}</option>
                      {field.createNewValue && (
                        <option value="new">{field.createNewValue}</option>
                      )}
                      {field?.values?.map?.((value) => {
                        return (
                          <option
                            key={value[field.mapping.value]}
                            value={value[field.mapping.value]}
                          >
                            {value[field.mapping.display]}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                );
              case "google-map-autocomplete":
                return (
                  <div key={field.name} className="mb-4">
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor={field.name}
                    >
                      {field.label}
                      {field.required && (
                        <span className="text-red-500"> *</span>
                      )}
                    </label>
                    {isLoaded && (
                      <Autocomplete
                        onLoad={(autocomplete) => {
                          autoComplete.current = autocomplete;
                        }}
                        onPlaceChanged={async () => {
                          const place = autoComplete.current.getPlace();
                          const parsed = parseAddress(place);

                          let cityAndTeam = null;
                          
                          try {
                            cityAndTeam = await getCityAndTeam(
                              parsed.location.coordinates[1],
                              parsed.location.coordinates[0]
                            );

                            setStore({
                              ...store,
                              _city: cityAndTeam.city._id,
                              _team: cityAndTeam.team._id,
                              ...parsed,
                            });

                            setManualMarket(false);
                            setTempAddress(null);
                          } catch (e) {
                            dispatch(
                              addToast({
                                message:
                                  "Unable to determine market for this address, please ensure DSP coverage and select market manually",
                                type: "warning",
                              })
                            );
                            setManualMarket(true);
                            setStore({
                              ...store,
                              ...parsed,
                            });
                          } finally {
                            setTempAddress(null);
                          }
                        }}
                      >
                        <input
                          className="form-input w-96"
                          type="text"
                          value={field.value}
                          name={field.name}
                          onChange={handleChange}
                        />
                      </Autocomplete>
                    )}
                  </div>
                );
              case "divider":
                return (
                  <div key={field.section} className="mb-4">
                    <h2 className="text-lg font-semibold">{field.section}</h2>
                  </div>
                );
              case "checkbox":
                return (
                  <div
                    key={field.name}
                    className="mb-4 flex gap-2 items-center"
                  >
                    <div className="items-center">
                      <input
                        id={field.name}
                        type="checkbox"
                        name={field.name}
                        checked={store?.[field.path]}
                        onChange={handleChange}
                      />
                    </div>
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor={field.name}
                    >
                      {field.label}
                    </label>
                  </div>
                );

              case "checkboxes":
                return (
                  <div key={field.name} className="mb-4">
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor={field.name}
                    >
                      {field.label}
                    </label>
                    <div className="flex items-center">
                      {field?.values?.map?.((value) => {
                        return (
                          <div
                            key={value[field.mapping.value]}
                            className="mr-2"
                          >
                            <input
                              id={`checkbox-${value[field.mapping.value]}`} // Unique ID for the checkbox
                              type="checkbox"
                              name={field.name}
                              value={value[field.mapping.value]}
                              onChange={handleChange}
                              checked={
                                store?.[field.path] === true ||
                                store?.[field.path]?.includes?.(
                                  value[field.mapping.value]
                                )
                              }
                            />
                            <label
                              htmlFor={`checkbox-${value[field.mapping.value]}`} // Associates label with the checkbox
                              className="ml-1"
                            >
                              {value[field.mapping.display]}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              case "text":
                return (
                  <div key={field.name} className="mb-4">
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor={field.name}
                    >
                      {field.label}
                      {field.required && (
                        <span className="text-red-500"> *</span>
                      )}
                    </label>
                    <div className="flex gap-1 items-center">
                      {field.field_prefix && (
                        <span className="flex">{field.field_prefix}</span>
                      )}
                      <input
                        className="form-input w-96"
                        type={field.type}
                        value={store?.[field.path]}
                        name={field.name}
                        onChange={handleChange}
                        disabled={field.disabled}
                      />
                    </div>
                  </div>
                );
              case "custom":
                return (
                  <div key={field.name} className="mb-4">
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor={field.name}
                    >
                      {field.label}
                      {field.required && (
                        <span className="text-red-500"> *</span>
                      )}
                    </label>
                    <div className="flex gap-1 items-center">
                      {field.content}
                    </div>
                  </div>
                );
            }
          })}

          <div className={"flex gap-2 justify-end"}>
            <SecondaryButton loading={processing} onClick={closeModal}>
              Cancel
            </SecondaryButton>
            <PrimaryButton
              loading={processing}
              onClick={() => {
                if (store.id === "new" && createdOrg) {
                  setShowBillingModal(true);
                } else {
                  submit();
                }
              }}
            >
              {store.id === "new" ? "Create" : "Update"}
            </PrimaryButton>
          </div>
        </div>
      );
    },
    [store, processing]
  );

  // Define tabs for the modal
  const modalTabs = useMemo(() => [
    { 
      id: "settings", 
      label: "Store Settings",
      disabled: store.id === "new"
    },
    { 
      id: "users", 
      label: "Users",
      disabled: store.id === "new"
    },
    { 
      id: "payment", 
      label: "Payment Settings",
      disabled: store.id === "new"
    },
    { 
      id: "feed", 
      label: "Inventory Feed",
      disabled: store.id === "new"
    }
  ], [store.id]);

  if (!store) {
    return null;
  }
  return (
    <ModalBasic
      modalOpen={Boolean(id)}
      title={store?.name || ""}
      setModalOpen={() => closeModal()}
      width={"5xl"}
    >
      <ModalBasic
        modalOpen={showBillingModal}
        setModalOpen={setShowBillingModal}
        width={"xl"}
        title={"Billing"}
      >
        <div className="mb-4">
          <div className="flex items-center">
            <div className="mr-2">
              <input
                id={`checkbox-create-new-subscription`} // Unique ID for the checkbox
                type="checkbox"
                name="Create New Subscription"
                onChange={(e) => {
                  setCreateNewSubscription(e.target.checked);
                }}
                checked={createNewSubscription}
              />
            </div>
            <label
              htmlFor={`checkbox-create-new-subscription`} // Associates label with the checkbox
              className="ml-1"
            >
              Create New Subscription
            </label>
          </div>
          {!createNewSubscription && (
            <>
              <div className="mb-4">
                <>
                  <label
                    className="block text-sm font-medium mb-1"
                    htmlFor={"direct_web_url"}
                  >
                    Stripe Customer Account
                  </label>
                  <div className="flex gap-2 items-center">
                    {!existingStripeCustomer ? (
                      "Link existing customer "
                    ) : (
                      <>
                        {existingStripeCustomer.id}{" "}
                        <Tooltip>{existingStripeCustomer.email}</Tooltip>
                      </>
                    )}
                    <SecondaryButton
                      loaing={processing}
                      onClick={() => {
                        setShowFindStripeCustomerModal(true);
                      }}
                      size="sm"
                    >
                      {existingStripeCustomer ? "Replace" : "Link Existing"}
                    </SecondaryButton>
                  </div>
                </>
              </div>
              <div className="mb-4">
                <>
                  <label
                    className="block text-sm font-medium mb-1"
                    htmlFor={"direct_web_url"}
                  >
                    Stripe Subscription
                  </label>
                  <div className="flex gap-2 items-center">
                    {!existingStripeCustomer
                      ? "Link existing customer first "
                      : existingStripeSubscription
                      ? existingStripeSubscription.id
                      : "Link existing subscription"}
                    <SecondaryButton
                      loaing={processing}
                      disabled={!existingStripeCustomer}
                      onClick={() => {
                        setShowFindStripeSubscriptionModal(true);
                      }}
                      size="sm"
                    >
                      {existingStripeSubscription ? "Replace" : "Link Existing"}
                    </SecondaryButton>
                  </div>
                </>
              </div>
            </>
          )}
      
          {createNewSubscription && (
            <>
              <label className="block text-sm font-medium mb-1">
                Subscription type
              </label>
              <div className="flex gap-1 items-center mb-2">
                <select
                  className="form-select"
                  name={"Subscription Type"}
                  value={newSubscriptionType}
                  onChange={(e) => {
                    setNewSubscriptionType(e.target.value);
                  }}
                >
                  <option value={"basic_monthly"}>Basic - Monthly</option>
                  <option value={"growth_monthly"}>Growth - Monthly</option>
                </select>
              </div>

              <label className="block text-sm font-medium mb-1">
                Free Trial Day
              </label>
              <div className="flex gap-1 items-center">
                <input
                  className="form-input  w-full mb-2"
                  type="number"
                  value={freeTrialDays}
                  name={"Free Trial Days"}
                  max={99}
                  min={1}
                  onChange={(e) => {
                    let val = parseInt(e.target.value);
                    setTrialDayError("");
                    if (val < 1) {
                      setTrialDayError(
                        "Billing must start at least one day from now"
                      );
                      return;
                    }
                    if (val > 99) {
                      setTrialDayError("Billing must start within 99 days");
                      return;
                    }
                    setFreeTrialDays(val);
                  }}
                />
              </div>
              {trialDayError && (
                <span className="text-red-500 text-sm ">{trialDayError}</span>
              )}
              {!trialDayError && (
                <span className={"text-sm "}>
                  Billing will start on:{" "}
                  <span className={"font-bold"}>
                    {moment().add(freeTrialDays, "days").format("MMM DD, YYYY")}
                  </span>
                </span>
              )}
              <div className={"mt-4 h-48"}>
                <Multiselect
                  className={"h-48"}
                  placeholder={"Select Coupons"}
                  options={stripeCoupons
                    ?.map?.((coupon) => {
                      if (!coupon.valid) return null;
                      if (
                        coupon.max_redemptions &&
                        coupon.max_redemptions <= coupon.times_redeemed
                      )
                        return null;
                      return {
                        name: coupon.name,
                        id: coupon.id,
                      };
                    })
                    .filter((c) => c)} // Options to display in the dropdown
                  selectedValues={selectedCoupons} // Preselected value to persist in dropdown
                  onSelect={(selectedList, selectedItem) => {
                    setSelectedCoupons(selectedList);
                  }}
                  onRemove={(selectedList, removedItem) => {
                    setSelectedCoupons(selectedList);
                  }}
                  displayValue="name" // Property name to display in the dropdown options
                />
              </div>
            </>
          )}
          <div>
            <div className={"flex gap-2 mt-2 justify-end"}>
              <SecondaryButton
                loading={processing}
                onClick={() => {
                  setShowBillingModal(false);
                }}
              >
                Cancel
              </SecondaryButton>
              <PrimaryButton
                loading={processing}
                onClick={async () => {
                  if (
                    !createNewSubscription &&
                    (!existingStripeCustomer || !existingStripeSubscription)
                  ) {
                    dispatch(
                      addToast({
                        message:
                          "Please link existing customer and subscription",
                        type: "error",
                      })
                    );
                    return;
                  }
                  submit();
                }}
              >
                Create
              </PrimaryButton>
            </div>
          </div>
        </div>
      </ModalBasic>
      <FindStripeCustomerModal
        merchant={{}}
        modalOpen={showFindStripeCustomerModal}
        setModalOpen={setShowFindStripeCustomerModal}
        setMerchantCustomer={(customer) => {
          if (customer.id !== existingStripeCustomer?.id) {
            setExistingStripeCustomer(customer);
            setExistingStripeSubscription("");
          }
        }}
      />
      <FindStripeSubscriptionModal
        modalOpen={showFindStripeSubscriptionModal}
        setModalOpen={setShowFindStripeSubscriptionModal}
        setMerchantSubscription={(subscription) => {
          setExistingStripeSubscription(subscription);
        }}
        customerID={existingStripeCustomer.id}
      />
      <div className="flex-1 min-h-96">
        <div className="md:py-8">
          {/* Blocks */}
          <div className="space-y-4">
            <div>
              {/* Tabbed Navigation */}
              <div className="mb-4">
                <TabbedNavigation
                  tabs={modalTabs}
                  activeTab={currentView}
                  onTabChange={setCurrentView}
                  variant="default"
                  size="md"
                />
              </div>
            </div>
            {currentView === "payment" && form(paymentFields)}
            {currentView === "settings" && form(fields)}
            {currentView === "users" && (
              <UsersTable
                users={users}
                orgID={store._org}
                storeID={store.id || store._id}
                storeName={store.name}
                refetch={() => {
                  getMerchantUsers(store.id || store._id).then((res) => {
                    setUsers(res.users);
                  });
                }}
              />
            )}
            {currentView === "feed" && (
              <InventoryFeed storeID={store.id || store._id} />
            )}
            <ModalBasic
              modalOpen={showCreateNewMerchant}
              setModalOpen={(e) => {
                if (creatingOrg) {
                  return;
                }
                setShowCreateNewMerchant(e);
              }}
              title={"Create New Merchant"}
              width={"md"}
            >
              <div>
                <label className="block text-sm font-medium mb-1">
                  Merchant Account name
                </label>
                <div className="flex gap-1 items-center">
                  <input
                    className="form-input  w-full"
                    type="text"
                    value={newMerchantName}
                    name={"Merchant name"}
                    onChange={(e) => {
                      setNewMerchantName(e.target.value);
                    }}
                  />
                </div>
                <label className="block text-sm font-medium mb-1">
                  Billing Email
                </label>
                <div className="flex gap-1 items-center">
                  <input
                    className="form-input  w-full"
                    type="text"
                    value={newMerchantBillingEmail}
                    name={"Billing email"}
                    onChange={(e) => {
                      setNewMerchantBillingEmail(e.target.value);
                    }}
                  />
                </div>
                <div className={"flex gap-2 mt-2 justify-end"}>
                  <SecondaryButton
                    loading={creatingOrg}
                    onClick={() => {
                      setShowCreateNewMerchant(false);
                    }}
                  >
                    Cancel
                  </SecondaryButton>
                  <PrimaryButton
                    loading={creatingOrg}
                    onClick={async () => {
                      setCreatingOrg(true);
                      if (!newMerchantName) {
                        dispatch(
                          addToast({
                            message: "Merchant name is required",
                            type: "error",
                          })
                        );
                        setCreatingOrg(false);
                        return;
                      } else if (!newMerchantBillingEmail) {
                        dispatch(
                          addToast({
                            message: "Billing email is required",
                            type: "error",
                          })
                        );
                        setCreatingOrg(false);
                        return;
                      }
                      try {
                        const res = await createOrg(
                          newMerchantName,
                          newMerchantBillingEmail
                        );
                        await dispatch(getMerchants());
                        setStore({
                          ...store,
                          _org: res.org._id,
                        });
                      } catch (e) {
                        dispatch(
                          addToast({
                            message: "Unable to create ",
                            type: "error",
                          })
                        );
                      } finally {
                        setCreatingOrg(false);
                        setCreatedOrg(true);
                        setShowCreateNewMerchant(false);
                      }
                    }}
                  >
                    Create
                  </PrimaryButton>
                </div>
              </div>
            </ModalBasic>
          </div>
        </div>
      </div>
      <FindStripeCustomerModal
        modalOpen={findStripeCustomerModal}
        setModalOpen={setFindStripeCustomerModal}
        setMerchantCustomer={(customer) => {
          setSellerStripeCustomer(customer);
          handleChange("stripe_cust_id", customer.id);
        }}
        merchant={store}
      />
    </ModalBasic>
  );
};
export default StoreModal;
